module.exports = __webpack_public_path__ + "static/media/brinjal.6eb1920c.svg";